import { render } from "./App3.vue?vue&type=template&id=674663f7"
import script from "./App3.vue?vue&type=script&lang=js"
export * from "./App3.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__